import { render, staticRenderFns } from "./daisy-message-table.component.vue?vue&type=template&id=cac4fc58&scoped=true&"
import script from "./daisy-message-table.component.vue?vue&type=script&lang=ts&"
export * from "./daisy-message-table.component.vue?vue&type=script&lang=ts&"
import style0 from "./daisy-message-table.component.vue?vue&type=style&index=0&id=cac4fc58&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac4fc58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VTooltip})
